import {z} from 'zod'

export type StripeCustomerId = `cus_${string}`
export const StripeCustomerId = z.string().startsWith('cus_') as z.ZodType<StripeCustomerId>
